/**
 * 业务整段朗读 API 开关（测完改回 'tts1' 即可；口语广场 tts_ticket 不受影响）
 * - 'tts1'：Cibei 优先，Azure 兜底
 * - 'tts3'：Edge TTS 优先，Azure 兜底（form-urlencoded；不支持 phoneme）
 */
export const COURSE_TTS_API = 'tts3'

/**
 * 口语广场流式 TTS 通道一键开关
 *
 * - `true`：Edge WS（`tts_ws_ticket` → `WS /ws/audio/speech`）；失败由页面 toast，**不**降级 HTTP
 * - `false`：回旧 Kokoro 流式（`tts_ticket` → `ttsStreamSession`）
 *
 * 与 `COURSE_TTS_API`（游戏/查词 HTTP）无关。发现问题改成 `false` 即可一键切回。
 */
export const SPEAKING_PLAZA_USE_EDGE_TTS_WS = true

/**
 * 【不对公开展示】发音语速自定义入口 — 内部调试专用
 *
 * - 产品决策：语速调节功能不会对普通用户公开展示；全站默认固定语速（tts3 为 -10）。
 * - 仅下列 userInfo.id 可在设置页看到并调节滑条，便于内部试听 Edge 语速。
 * - 非名单用户：设置页无入口；出站/保存一律走 DEFAULT_TTS_UI_SPEED。
 * - 正式对全员开放前：须产品确认后再去掉白名单门控。
 */
export const TTS_SPEED_SETTING_USER_IDS = ['7018', '2099685608']

/** 是否允许自定义发音语速（内部白名单；非公开能力） */
export function canCustomizeTtsSpeed (userId) {
  const id = String(userId ?? '').trim()
  return id !== '' && TTS_SPEED_SETTING_USER_IDS.includes(id)
}
